import QueryGetSfAccountAndOppMeta from '../graphql/queries/QueryGetSfAccountAndOppMeta';

/** Enquire `payload.salesforce` shape (GraphQL still returns accountId / opportunityId). */
export const emptySfAccountAndOppMeta = () => ({
  calculatedAccountId: null,
  calculatedOpportunityId: null,
  opportunityStageName: null
});

function normalizeSfAccountAndOppMeta(raw) {
  if (!raw || typeof raw !== 'object') {
    return emptySfAccountAndOppMeta();
  }
  const calculatedAccountId = raw.calculatedAccountId ?? raw.accountId ?? null;
  const calculatedOpportunityId = raw.calculatedOpportunityId ?? raw.opportunityId ?? null;
  return {
    calculatedAccountId: calculatedAccountId != null ? calculatedAccountId : null,
    calculatedOpportunityId: calculatedOpportunityId != null ? calculatedOpportunityId : null,
    opportunityStageName: raw.opportunityStageName != null ? raw.opportunityStageName : null
  };
}

/** Loads `getSfAccountAndOppMeta` for calculator enquire. Always returns explicit keys; all null on validation failure, GraphQL errors, or thrown errors. */
export async function fetchSfAccountAndOppMeta(apollo, { customer, introducerName, region, isNZ }) {
  const companyName = String(customer?.name || '').trim();
  const companyABN = String(customer?.abn || '').trim();

  if (!companyName || !companyABN) {
    return emptySfAccountAndOppMeta();
  }

  const regionParam = (region && String(region).trim()) || (isNZ ? 'NZ' : 'AU');

  try {
    const { data, errors } = await apollo.query({
      query: QueryGetSfAccountAndOppMeta,
      fetchPolicy: 'network-only',
      variables: {
        region: regionParam,
        companyABN,
        companyName,
        introducerOrgName: introducerName ? String(introducerName).trim() : null,
        salesforceAccountId:
          customer?.salesforceAccountId || customer?.accountId ? String(customer.salesforceAccountId || customer.accountId).trim() : null
      }
    });

    if (errors?.length) {
      // eslint-disable-next-line no-console
      console.error(errors);
      return emptySfAccountAndOppMeta();
    }

    return normalizeSfAccountAndOppMeta(data?.getSfAccountAndOppMeta);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    return emptySfAccountAndOppMeta();
  }
}
